import styled from "styled-components"

export const WidthAdjustmentDiv = styled.div`
    width: 100%;
    max-width: 450px;
    left: 50%;
    transform: translateX(-50%);
`